import { Injectable, signal } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';
import {HttpClient} from "@angular/common/http";
import {OfferModifier, OfferSelection, OrderItem} from "./chat.service";
import {cloneDeep, each, filter, get} from "lodash";
import {TabitOrderProcessService} from "../tabit-order/tabit-order-process.service";

@Injectable({ providedIn: 'root' })
export class ChatBasketService {
	constructor(
		private http: HttpClient,
		private appService: AppService,
		private orderService: OrderService,
		private orderProcessService: TabitOrderProcessService,
		private orderUtils: OrderItemsUtilsService
	) {

	}

	lastBasketOffers = '[]';
	getBasketChatMessage() {
		const parsedOffers =  this.getBasketForChat();
		const parsedOffersText =  JSON.stringify(parsedOffers);
		if (parsedOffersText != this.lastBasketOffers) {
			this.lastBasketOffers = parsedOffersText;
			return `@{"command":"newMealRecommendation","parameters":{"items":${parsedOffersText}}}@`;
		}
	}

	getBasketForChat(): Array<string> {
		const parsedOrder =  this.orderProcessService.getPreparedOrder_forserver(this.orderService.$storage);
		const parsedOffers = parsedOrder.orderedOffers.map(oOffer => {
			return {
				"offerId": oOffer.offer,
				"offerName": oOffer.name,
				"orderedItems": oOffer.orderedItems.map(oi => {
					return {
						itemName: oi.name,
						itemId: oi.item,
						selectionId: oi.itemGroup,
						itemGroupName: oi.itemGroupName,
						selectedModifiers: oi.selectedModifiers.map(mod => {
							return {
								"modifierName": mod.name,
								"modifierId": mod.modifier,
								"modifierGroupName": mod.modifierGroupName,
								"modifierGroupId": mod.modifierGroup,
								"formationUnit": "רגיל",
								"count": 1
							}
						}),
						removedModifiers: oi.removedModifiers.map(mod => {
							return {
								"modifierName": mod.name,
								"modifierId": mod.modifier,
								"modifierGroupName": mod.modifierGroupName,
								"modifierGroupId": mod.modifierGroup
							}
						}),
					}
				})
			}
		});
		return parsedOffers;
	}


	//-------------------------------------------------------------------------------------------------->

	getPreparedModifiers(oi) {
		const getPreparedModifier= (aiMod, action?) => {
			return { ...aiMod, modifierGroupId: aiMod.modificationId, modifierId: aiMod.modifierId, action}
		}
		let selectedModifiers: OfferModifier[] = get(oi, 'selectedModifiers', []).map(getPreparedModifier);
		selectedModifiers = selectedModifiers.concat(get(oi, 'removedModifiers', []).map(o => getPreparedModifier(o, "REMOVE")));
		return selectedModifiers;
	}

	processSystemOrderItem(orderItem: OrderItem, viewItem: any): any {
		try {
			const clonedOffer = cloneDeep(viewItem);
			clonedOffer.total = clonedOffer.price;
			this.orderUtils.prepareViewItem(this.orderService.$storage.catalog, clonedOffer);
			this.orderUtils.prepareSelectItem(this.orderService.$storage.catalog, clonedOffer)

			if (clonedOffer.isWeight) {
				console.warn("weight not supported", clonedOffer);
			} else {
				if (clonedOffer._item && clonedOffer._item._addPrice) {
					clonedOffer.total += clonedOffer._item._addPrice;
				}
			}
			if (!clonedOffer.quantity) clonedOffer.quantity = 1;

			let selectedModifiers: OfferModifier[] = [];
			let itemSelections: OfferSelection[] = [];

			each(get(orderItem, 'orderedItems', []), oi => {
				if (oi.selectionId) {
					itemSelections.push({
						item: oi.selectionItemId,
						itemGroup: oi.selectionId,
						name: oi.selectionName,
						selectedModifiers: this.getPreparedModifiers(oi)
					});
				} else {
					selectedModifiers = selectedModifiers.concat(this.getPreparedModifiers(oi))
				}
			});


			if (selectedModifiers?.length) {
				this.applySelectedModifiers(clonedOffer, selectedModifiers, false);
			}
			if (itemSelections?.length) {
				this.applySelectedSelections(clonedOffer, itemSelections);
			}

			this.calculateOfferTotal(clonedOffer, viewItem);
			this.orderUtils.prepareOfferSummary(clonedOffer, true);

			clonedOffer.isTabotOffer = true; // Mark as a bot request

			this.setOfferValidationFlags(clonedOffer);
			const hasValidationIssues = clonedOffer.offerNotValid === true;

			if (orderItem.quantity) {
				clonedOffer.quantity = orderItem.quantity;
			}
			return { success: true, hasValidationIssues, basketOffer: clonedOffer };

		} catch (error) {
			console.error(`Failed to process item "${viewItem.name}":`, error);
			return { success: false, hasValidationIssues: false, basketOffer: null };
		}
	}


	private applySelectedSelections(clonedOffer: any, selections: OfferSelection[]): void {
		if (!selections?.length) {
			return;
		}

		// Validate cloned offer structure
		if (!clonedOffer?._offer?.selectionGroups?.length) {
			console.warn('Invalid cloned offer structure - missing selection groups');
			return;
		}

		selections.forEach((selection: OfferSelection) => {
			// Validate selection object
			if (!selection?.itemGroup || !selection?.item) {
				console.warn('Invalid selection object:', selection);
				return;
			}

			const itemGroup = clonedOffer._offer.selectionGroups?.find(
				(itemGroup) => itemGroup.itemGroup === selection.itemGroup
			);

			if (!itemGroup?.items) {
				console.warn(`Selection group not found for ID: ${selection.itemGroup}`);
				return;
			}

			// const item = itemGroup.items.find((item) => item._id === selection.item);
			let item = itemGroup.items.find((item) => item.name === selection.name || item?._item.realName === selection.name);

			// If not found, try flexible matching (contains)
			if (!item) {
				item = itemGroup.items.find((item: any) => {
					const itemName = item.name || '';
					const selectionName = selection.name || '';

					// Check if one contains the other
					if (itemName.includes(selectionName) || selectionName.includes(itemName)) {
						return true;
					}
					return false;
				});
			}

			if (!item) {
				console.warn(`Item not found for ID: ${selection.item} in group: ${selection.itemGroup}`);
				return;
			}

			// Apply selection
			item._selected = true;

			// Validate item structure before processing
			if (!item._item) {
				console.warn('Item missing _item property:', item);
				return;
			}

			this.orderUtils.prepareItem(this.orderService.$storage.catalog, item._item, clonedOffer);

			if (selection?.selectedModifiers?.length) {
				selection.selectedModifiers.forEach(modifier => {
					const modifierGroup = item._item.modifierGroups.find(
						(group: any) => group.modifierGroup === modifier.modifierGroupId
					);
					if (modifierGroup?.modifiers) {

						let selectedModifier = modifierGroup.modifiers.find((mod: any) => {
								if (mod._id === modifier.modifierId) {
									mod.action = modifier.action;
									return true;
								}
							}
						);
						if (selectedModifier) {
							// Apply modifier selection
							const modifierPrice = selectedModifier.price;
							if (selectedModifier.action === 'REMOVE') {
								if (modifierPrice > 0) {
									clonedOffer.price -= modifierPrice;
									clonedOffer.viewPrice -= modifierPrice;
								}
								delete selectedModifier.formationUnit;
							} else if (selectedModifier.defaultFormationUnit && selectedModifier.formationUnit) {
								//	default no action needed
							} else {
								if (modifierPrice > 0) {
									clonedOffer.price += modifierPrice;
									clonedOffer.viewPrice += modifierPrice;
								}
								selectedModifier._selected = true;
								// Set formation unit with safety check
								const formationUnit = clonedOffer._item?.formation?.[0];
								if (formationUnit) {
									selectedModifier.formationUnit = formationUnit;
								} else {
									console.warn('Formation unit not available for modifier');
								}
							}
							this.orderUtils.prepareItemSummary(item._item)
						}
					}
				});
			}
			this.addSelectionGroupItem(itemGroup, item, clonedOffer);
		});

		this.orderUtils.prepareOfferSelectionGroups(clonedOffer);
		console.log('Processed cloned offer:', clonedOffer);
	}

	private addSelectionGroupItem(group: any, member: any, clonedOffer: any, isEdit: boolean = false): void {
		// Validate inputs
		if (!group || !member || !clonedOffer) {
			console.warn('Invalid parameters passed to addSelectionGroupItem');
			return;
		}

		// Initialize totals
		clonedOffer.total = clonedOffer.total || 0;
		member._selected = true;

		let count: number = 0;
		let selectedN: number = 0;

		// Calculate selection counts for non-edit mode
		if (!isEdit && group?.items) {
			const selected = filter(group.items, { '_selected': true });
			count = 1;
			selectedN = selected.length;
		}

		// Get pricing information with safety checks
		const oldTotal = member._item?.oldTotal || 0;
		const newTotal = member._item?.total || 0;

		// Update totals based on edit mode
		if (isEdit && member.count) {
			clonedOffer.total -= member.count * oldTotal;
			clonedOffer.total += member.count * newTotal;
		} else {
			clonedOffer.total += newTotal;
			member.count = (member.count || 0) + 1;
		}

		// Update old total for future calculations
		if (member._item) {
			member._item.oldTotal = newTotal;
		}

		// Update group properties
		if (group) {
			// Remove required flag (note: fixed typo from _requiered to _required)
			delete group._required;
			delete group._requiered; // Keep old typo for backward compatibility

			// Handle expandable/collapsed state for non-edit mode
			if (!isEdit && count === selectedN) {
				group._expandable = true;
				group._collapsed = true; // Fixed typo from _collpased
			}
		}

		// Update offer pricing
		clonedOffer.price = clonedOffer.total;
		clonedOffer.viewPrice = clonedOffer.total;
	}

	private applySelectedModifiers(clonedOffer: any, selectedModifiers: OfferModifier[], isRemoved: boolean): void {
		if (!selectedModifiers?.length) {
			return;
		}

		// Validate cloned offer structure before processing
		if (!clonedOffer?._item?.modifierGroups || !Array.isArray(clonedOffer._item.modifierGroups)) {
			console.warn('Invalid cloned offer structure - missing modifier groups');
			return;
		}

		selectedModifiers.forEach((modifier: OfferModifier) => {
			const modifierGroup = clonedOffer._item.modifierGroups.find(
				(group: any) => group.modifierGroup === modifier.modifierGroupId
			);
			if (!modifierGroup?.modifiers) {
				console.warn(`Modifier group not found for ID: ${modifier.modifierGroupId}`);
				return;
			}
			let selectedModifier = modifierGroup.modifiers.find((mod: any) => {
					if (mod._id === modifier.modifierId) {
						mod.action = modifier.action;
						return true;
					}
				}
			);
			if (!selectedModifier) {
				console.warn(`Modifier not found for ID: ${modifier.modifier}`);
				return;
			}

			const modifierPrice = selectedModifier.price;
			if (selectedModifier.action === 'REMOVE') {
				if (modifierPrice > 0) {
					clonedOffer.price -= modifierPrice;
					clonedOffer.viewPrice -= modifierPrice;
				}
				delete selectedModifier.formationUnit;
			} else if (selectedModifier.action && selectedModifier.defaultFormationUnit && selectedModifier.formationUnit) {
				//	default no action needed
			} else {
				if (modifierPrice > 0) {
					clonedOffer.price += modifierPrice;
					clonedOffer.viewPrice += modifierPrice;
				}
				selectedModifier._selected = true;
				// Set formation unit with safety check
				const formationUnit = clonedOffer._item?.formation?.[0];
				if (formationUnit) {
					selectedModifier.formationUnit = formationUnit;
				} else {
					console.warn('Formation unit not available for modifier');
				}
			}
			this.orderUtils.prepareOfferSelectionGroups(clonedOffer);
		});
	}

	/**
	 * Calculates the total price for an offer based on item type
	 */
	private calculateOfferTotal(clonedOffer: any, viewItem: any): void {
		if (viewItem.isWeight && viewItem.baseUnits) {
			// Weight-based items use view price
			clonedOffer.total = clonedOffer.viewPrice;
		} else {
			// Regular items use base price plus any additional charges
			clonedOffer.total = clonedOffer.price;
			if (clonedOffer._item?._addPrice) {
				clonedOffer.total += clonedOffer._item._addPrice;
			}
		}
	}

	/**
	 * Sets validation flags for offers that require special handling
	 */
	private setOfferValidationFlags(clonedOffer: any): void {
		// Handle items that require editing - mark as invalid to prevent auto-editing
		if (clonedOffer._enableEdit) {
			//clonedOffer.offerNotValid = true;
		}

		// Validate offer completeness - mark as invalid if requires sub-selections
		if (!this.orderUtils.validateOffer(clonedOffer)) {
			clonedOffer.offerNotValid = true;
			this.orderService.$storage.preventForward = true; // Prevent forward navigation if offer is not valid
		}

		/*if (!clonedOffer.offerNotValid) {
			clonedOffer?._offer?.selectionGroups.forEach(element => {
				element?.items.forEach((item: any) => {
					if (item?._item && !this.orderUtils.validateOffer(item, "modifier")) {
						clonedOffer.offerNotValid = true;
					}
					if (item?._offer && !this.orderUtils.validateOffer(item, "selection")) {
						clonedOffer.offerNotValid = true;
					}
				});
			});
		}*/
	}

	// ---------------------------------------------------------------------------------------------->
	// ---------------------------------------------------------------------------------------------->
	// ---------------------------------------------------------------------------------------------->

	getOfferSummary(offer) {
		const groups = [];

		// Check if selectionSummary already exists and use it (like in the template)
		if (offer?.selectionSummaryX?.length) {
			offer.selectionSummary.forEach(group => {
				if (group._visible) {
					const items = [];
					let groupTotalPrice = 0;

					group.items.forEach(item => {
						// Build item text like in template
						let itemText = '';
						let without = false;

						// Check if it's a "without" item
						if (item.without) {
							itemText = `${this.appService ? this.appService.translate('WITHOUT') : 'WITHOUT'} ${item.name || 'missing'}`;
							without = true;
						} else {
							// Add count if > 1
							if (item.count > 1) {
								itemText += `${item.count}*`;
							}
							itemText += item.name || 'missing';

							// Add price if exists and not without
							const itemPrice = item?._item?.total || item?.price || 0;
							if (itemPrice > 0) {
								itemText += ` +${itemPrice}`;
								groupTotalPrice += itemPrice * (item.count || 1);
							}

							// Add summary if exists
							if (item?._item?.summary?.text) {
								itemText += ` (${item._item.summary.text})`;
							}
						}

						items.push({
							...item,
							displayText: itemText,
							without: without,
							price: item?._item?.total || item?.price || 0,
							count: item.count || 1
						});
					});

					if (items.length) {
						groups.push({
							_id: group._id,
							name: group.name,
							_visible: group._visible,
							items,
							groupPrice: groupTotalPrice,
							displayText: `${group.name}: ${items.map(item => item.displayText).join(', ')}`
						});
					}
				}
			});
		}


		// If no selectionSummary, fall back to processing modifier and selection groups
		if (!groups.length) {
			// 1) Modifier groups
			if (offer?._item?.modifierGroups?.length) {
				offer._item.modifierGroups.forEach(group => {
					const selection = { modifiers: [], decisions: [] };
					let groupTotalPrice = 0;

					(group.modifiers || []).forEach(mod => {
						const without = mod.$isDefault && mod.defaultFormationUnit && !mod.formationUnit;
						const hasDecisions = !!mod?._item?.summary;

						if ((mod.formationUnit && (!mod.$isDefault || hasDecisions)) || without) {
							// Build display text like template
							let displayText = '';

							if (without) {
								displayText = `${this.appService ? this.appService.translate('WITHOUT') : 'WITHOUT'} ${mod.name}`;
							} else {
								if (mod.count > 1) {
									displayText += `${mod.count}*`;
								}
								displayText += mod.name;

								if (mod.price > 0) {
									displayText += ` +${mod.price}`;
									groupTotalPrice += mod.price * (mod.count || 1);
								}
							}

							const modWithDisplay = {
								...mod,
								displayText,
								without,
								price: mod.price || 0,
								count: mod.count || 1
							};

							if (!group.singleSelection) selection.modifiers.push(modWithDisplay);
							else selection.decisions.push(modWithDisplay);
						}
					});

					const items = [...selection.decisions, ...selection.modifiers];
					if (items.length) {
						groups.push({
							_id: group._id,
							name: group.name,
							_visible: group._visible,
							items,
							isModifier: true,
							groupPrice: groupTotalPrice,
							displayText: `${group.name}: ${items.map(item => item.displayText).join(', ')}`
						});
					}
				});
			}

			// 2) Selection groups - check both locations
			const selectionGroups = offer?.selectionGroups || offer?._offer?.selectionGroups;
			if (selectionGroups?.length) {
				selectionGroups.forEach(sg => {
					const items = [];
					let itemsCounter = 0;
					let limitException = !!sg.limitException;
					let groupTotalPrice = 0;

					(sg.items || []).forEach(it => {
						if (it._selected) {
							itemsCounter += it.count ?? 0;

							const hasException = this.checkThirdLevelMinMaxException(it._item);
							if (!limitException && hasException) {
								limitException = true;
							}

							// Build display text
							let displayText = '';
							if (it.count > 1) {
								displayText += `${it.count}*`;
							}
							displayText += it.name;

							const itemPrice = it.price || it._item?.price || 0;
							if (itemPrice > 0) {
								displayText += ` +${itemPrice}`;
								groupTotalPrice += itemPrice * (it.count || 1);
							}

							if (it?._item?.summary?.text) {
								displayText += ` (${it._item.summary.text})`;
							}

							items.push({
								...it,
								displayText,
								without: false,
								price: itemPrice,
								count: it.count || 1
							});
						}
					});

					if (!limitException) {
						const max = sg.selectionCount ?? Number.POSITIVE_INFINITY;
						const min = sg.minSelectionCount ?? 0;
						limitException = itemsCounter > max || itemsCounter < min;
					}

					if (items.length) {
						groups.push({
							_id: sg._id,
							name: sg.name,
							_visible: sg._visible,
							items,
							limitException,
							groupPrice: groupTotalPrice,
							displayText: `${sg.name}: ${items.map(item => item.displayText).join(', ')}`
						});
					}
				});
			}
		}

		// Calculate total price for the entire offer
		const totalPrice = groups.reduce((total, group) => total + (group.groupPrice || 0), 0) + (offer.price || offer.viewPrice || 0);

		// Add weight summary if exists (like in template)
		let weightSummary = '';
		if (offer.isWeight && offer._item?.$summary) {
			weightSummary = `${this.appService ? this.appService.translate('_WEIGHT.item_weight') : 'Weight'}: ${offer._item.$summary}`;
		}

		// Add remarks if exists (like in template)
		let remarks = '';
		if (offer.offerRemrks || (offer.preSelection?.offers?.length && offer.preSelection?.offers[0].offerRemrks)) {
			remarks = offer.offerRemrks || offer.preSelection.offers[0].offerRemrks;
		}

		// Build the full text like in the UI template
		const summaryLines = [];

		// Add offer title and quantity at the top
		const quantityText = offer.quantity && offer.quantity > 1 ? offer.quantity : 1;
		summaryLines.push(`${quantityText} ${offer.name || 'missing'}`);

		// Add weight summary if exists
		if (weightSummary) {
			summaryLines.push(weightSummary);
		}

		// Add each group with its items
		groups.forEach(group => {
			group.items.forEach(item => {
				let itemLine = '';

				// Add count with * format (always show count, even if 1)
				itemLine = `${item.count || 1}`;
				if (item.count > 1) {
					itemLine += '*';
				}

				// Add item name
				itemLine += ` ${item.name || 'missing'}`;

				// Add price if exists and > 0 - fix double ₪ issue
				if (item.price > 0) {
					const totalItemPrice = item.price * (item.count || 1);
					const formattedPrice = `+${totalItemPrice}`;
					// Only add + if it's an additional cost
					if (totalItemPrice > 0 && !item.without) {
						itemLine += formattedPrice;
					}
				} else if (item.without) {
					// For "without" items, show the group name and what's being removed
					itemLine = `${group.name}: ${item.displayText}`;
				}

				// Add summary/modifications if exists
				if (item._item?.summary?.text && !item.without) {
					itemLine += ` (${item._item.summary.text})`;
				}

				summaryLines.push(itemLine.trim());
			});
		});

		// Add remarks at the end if exists
		if (remarks) {
			summaryLines.push(`${remarks}`);
		}

		// Add total price line - fix double ₪ issue
		const formattedTotal = `${totalPrice}`;
		summaryLines.push(formattedTotal);

		return {
			offerId: offer._id,
			offerName: offer.name,
			offerBasePrice: offer.price || offer.viewPrice || 0,
			totalPrice: totalPrice,
			quantity: offer.quantity || 1,
			groups,
			weightSummary,
			remarks,
			// Full text representation like in template
			fullText: summaryLines.length > 0 ? summaryLines.toString() : ''
		};
	}

	checkThirdLevelMinMaxException(_item) {
		let hasException = false;
		const _itemModifiers = get(_item, 'modifierGroups');

		each(_itemModifiers, itemModifier => {
			// If we already have an exception > return (no more runs needed)
			if (hasException) return;

			let itemsCounter = 0;

			each(itemModifier.modifiers, modifier => {
				itemsCounter = (itemsCounter + (modifier.count || 0));
			})

			// If the counter is outside the modifier boundaries > it's an exception
			hasException = itemModifier.max && (itemsCounter > itemModifier.max) || itemModifier.min && (itemsCounter < itemModifier.min);
		})

		return hasException;
	}

	// ---------------------------------------------------------------------------------------------->
	// ---------------------------------------------------------------------------------------------->
	// ---------------------------------------------------------------------------------------------->

	/**
	 * Removes all Tabot offers from the basket
	 */
	clearTabotOffersFromBasket(): void {
		if (this.orderService.$storage.basket) {
			this.orderService.$storage.basket = [];
			if (this.orderService.$storage?.order?.offerCounters) this.orderService.$storage.order.offerCounters = {};
			if (this.orderService.$storage?.order?.offerMainCounters) this.orderService.$storage.order.offerMainCounters = {};
			this.orderService.calculateBasketTotal();
		}
		// if (this.dataService?.$storage?.basket?.length) {
		//     const nonBotOffers = filter(this.orderService.$storage?.basket, (offer) => !offer.isTabotOffer) || [];
		//     this.orderService.$storage.basket = nonBotOffers;
		// }
	}

	// ---------------------------------------------------------------------------------------------->
	// ---------------------------------------------------------------------------------------------->
	// ---------------------------------------------------------------------------------------------->


}

interface OfferProcessResult {
	readonly success: boolean;
	readonly hasValidationIssues: boolean;
	basketOffer: any
}
